import { useState } from 'react'
import { LuChevronUp } from 'react-icons/lu'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import Typography from '@mui/material/Typography'

interface CollapseSectionProps {
  subtitle: string
  defaultExpanded?: boolean
  children?: React.ReactNode
}

export default function CollapseSection({
  subtitle,
  defaultExpanded = false,
  children,
}: Readonly<CollapseSectionProps>) {
  const [expanded, setExpanded] = useState<boolean>(defaultExpanded)

  return (
    <Accordion expanded={expanded} onChange={(_, isExpanded) => setExpanded(isExpanded)}>
      <AccordionSummary expandIcon={<LuChevronUp size={18} />} sx={{ flexDirection: 'row-reverse', gap: 1 }}>
        <Typography variant="subtitle1">{subtitle}</Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  )
}
